import ajax from "@/lib/ajax";


//排床 相关
export async function GetBedSchedulingList(payload: any){
	let res = await ajax.get('/api/services/app/BedScheduling/GetBedSchedulingList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertBedScheduling(payload: any){
	let res = await ajax.post('/api/services/app/BedScheduling/InsertBedScheduling', payload)
	return res.data.result
}
// 更新
export async function UpdateBedScheduling(payload: any){
	let res = await ajax.put('/api/services/app/BedScheduling/UpdateBedScheduling', payload)
	return res.data.result
}
// 删除
export async function DeleteBedScheduling(payload: any){
	let res = await ajax.delete('/api/services/app/BedScheduling/DeleteBedScheduling', {params:payload})
	return res.data.result
}

// 拖拽无序换床
export async function UnorderedBed(payload: any){
	let res = await ajax.post('/api/services/app/BedScheduling/UnorderedBed', payload)
	return res.data.result
}


//排床模板 相关
export async function GetBedSchedulingTempList(payload: any){
	let res = await ajax.get('/api/services/app/BedScheduling/GetBedSchedulingTempList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertBedSchedulingTemp(payload: any){
	let res = await ajax.post('/api/services/app/BedScheduling/InsertBedSchedulingTemp', payload)
	return res.data.result
}
// 同步
export async function SyncBedSchedulingByTemp(payload: any){
	let res = await ajax.post('/api/services/app/BedScheduling/SyncBedSchedulingByTemp', payload)
	return res.data.result
}
// 更新
export async function UpdateBedSchedulingTemp(payload: any){
	let res = await ajax.put('/api/services/app/BedScheduling/UpdateBedSchedulingTemp', payload)
	return res.data.result
}
// 删除
export async function DeleteBedSchedulingTemp(payload: any){
	let res = await ajax.delete('/api/services/app/BedScheduling/DeleteBedSchedulingTemp', {params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/bedScheduling/index.ts